import clsx from 'clsx'
import { useTranslation } from 'react-i18next'

import type { PerPageSelectProps } from './type'

import { InputSelectSingle } from '@/components/ui'

import { options } from './const'

export const PerPageSelect = (props: PerPageSelectProps) => {
  const { t } = useTranslation()
  return (
    <div className={clsx('tw-flex tw-items-center')}>
      <p className={clsx('tw-text-sm')}>{`${t(
        'order.history.label.displayCount'
      )}：`}</p>
      <div className={clsx('tw-w-28')}>
        <InputSelectSingle<number>
          {...props}
          buttonLabel={t('order.history.label.displayCount')}
          options={options}
          height="md"
        />
      </div>
    </div>
  )
}
